import React, { useState, useEffect } from "react";
import { Environment } from "../environment";
import { parseUnits } from "@ethersproject/units";
import {
  useStakingContract,
  useTokenContract,
  useTokenContract1,
} from "../Hooks";
import { toast } from "react-toastify";
import { gasEstimationForAll } from "../utils";
import Loading from "./loading";
import "./Home.css";
import { logRoles } from "@testing-library/react";

export default function Home({
  init,
  init1,
  totalStakers,
  currentStaked,
  account,
  balance,
  reward,
}) {
  const [amount, setAmount] = useState(null);
  const [approve, setApprove] = useState(false);
  const [loading, setloading] = useState(false);
  const [decimals, setDecimals] = useState(false);
  const [currentBalance, setCurrentBalance] = useState();
  const tokenContract = useTokenContract();
  const tokenContract1 = useTokenContract1();
  const StakingContract = useStakingContract();
  let stakingAddress = Environment.StakingContract;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    try {
      const dec = +(await tokenContract1.methods.decimals().call());
      setDecimals(dec);
      let bal = balance.toLocaleString("fullwide", { useGrouping: false });
      console.log(bal, "balance--");
      setCurrentBalance(bal);
    } catch (e) {
      console.log(e, "error");
    }
  }, [balance, tokenContract1]);
  const approveHandler = async () => {
    if (!account) {
      toast.error("Error! Please connect your wallet.");
    } else if (!amount) {
      toast.error("Error! Please enter amount.");
    } else {
      try {
        setloading(true);
        const tx = await tokenContract.approve(
          stakingAddress,
          parseUnits(amount, decimals)
        );
        await tx.wait();
        toast.success("Success! Amount successfully approved.");
        setApprove(true);
        init();
        init1();
        setloading(false);
      } catch (error) {
        if (error?.data?.message) {
          toast.error(error?.data?.message);
        } else {
          toast.error(error?.message);
        }
        setloading(false);
      }
    }
  };

  const stakeHandler = async () => {
    try {
      setloading(true);
      let data1 = [parseUnits(amount, decimals)];
      let fn1 = StakingContract.estimateGas.stake;
      const tx1 = await StakingContract.stake(parseUnits(amount, decimals), {
        gasLimit: gasEstimationForAll(account, fn1, data1),
      });
      await tx1.wait();
      toast.success("Success! Transaction Confirmed.");
      setApprove(false);
      setloading(false);
      init();
      init1();
    } catch (error) {
      if (error?.data?.message) {
        toast.error(error?.data?.message);
      } else {
        toast.error(error?.message);
      }
      setloading(false);
    }
  };
  return (
    <div id="home-page">
      <Loading loading={loading} />

      <div className="content-holder">
        <div className="text-box">
          <div className="heads">
            <h1 className="main-head">
              Your LEDU Balance is :: {currentBalance}
            </h1>
          </div>
          <h5 className="your-address">YOUR ADDRESS is {account}</h5>
          <input
            type="number"
            min="0"
            step="1"
            max={currentBalance && currentBalance}
            className="input-field"
            placeholder="0"
            onChange={(e) => {
              setAmount(e.target.value);
            }}
          />
          <h6 className="show-address">
            CONTRACT ADDRESS {Environment.StakingContract}
          </h6>
          <div className="buttons">
            {approve ? (
              <button className="btn" onClick={stakeHandler}>
                Stake
              </button>
            ) : (
              <button className="btn" onClick={approveHandler}>
                Approve
              </button>
            )}
          </div>
        </div>
        <div className="card">
          <div className="card-container">
            <div className="staked-balance">
              <h2 className="text-desc">Your staked balance</h2>
              <h2 className="value-desc">{currentStaked} LEDU</h2>
            </div>

            <div className="rewards-unstake">
              <h2 className="text-desc">Rewards if un-staked today</h2>
              <h2 className="value-desc">{(+reward).toFixed(0)} LEDU</h2>
            </div>
            <div className="rewards-unstake">
              <h2 className="text-desc">LEDU Stakers</h2>
              <h2 className="value-desc">{totalStakers} </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
